/**
 * @file 教师管理页 · 类型与展示工具
 * @description 表单值、筛选条件与科目展示；科目对齐 `@/enum/common`。
 *
 * @whenToUse 仅教师管理页。
 * @whenNotToUse 其他业务模块。
 */

import { Subject, subjectMap } from '@/enum/common.ts'

/** 新建 / 编辑表单 */
export type TeacherFormValues = {
  /** 教师名称 */
  teacherName: string
  /** 教师账号（仅新建可填） */
  userName: string
  /** 授课科目 */
  subjects: string[]
  /** 登录密码；新建可空表示默认 123456 */
  password: string
}

/** 列表筛选条件 */
export type TeacherQuery = {
  /** 教师名称（模糊） */
  teacherName: string
  /** 教师账号（模糊） */
  userName: string
  /** 状态；空为全部，`1` 启用，`0` 禁用 */
  status: string
}

export const EMPTY_TEACHER_FORM: TeacherFormValues = {
  teacherName: '',
  userName: '',
  subjects: [],
  password: '',
}

export const EMPTY_TEACHER_QUERY: TeacherQuery = {
  teacherName: '',
  userName: '',
  status: '',
}

/** 科目下拉选项 */
export const SUBJECT_OPTIONS = Object.entries(subjectMap).map(
  ([value, label]) => ({ value, label }),
)

/**
 * 科目 value 转展示文案
 * @param values 科目枚举值集合
 */
export function formatSubjects(values: string[]): string {
  if (values.length === 0) return '—'
  return values
    .map((value) => subjectMap[value as Subject] ?? value)
    .join('、')
}
